
import axios from 'axios'

const base_path = (process.env && process.env.NODE_ENV == 'test') ?
  'http://localhost' : '';

async function verifyUserLoggedIn(isRefresh) {
  let refreshUrl = '/auth/isLoggedIn';

  if (isRefresh) {
    refreshUrl += '?refresh=true';
  }

  const response = await axios.get(base_path + refreshUrl);
  return response;
}

export default { verifyUserLoggedIn }